export default "assets/images/carbon_delivery-d990ea43.png";